var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0926 48.3396L35.0219 61.2905L32.6703 64.9104L12.74 51.9584L15.0926 48.3396Z",
    fill: "#7a65a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1159 33.1653L95.5671 39.1583L94.2332 43.2633L75.7831 37.2714L77.1159 33.1653Z",
    fill: "#7a65a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.827 16.1296L128.841 19.2192L107.314 40.2134L104.301 37.1239L125.827 16.1296Z",
    fill: "#7a65a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1972 36.5409L67.3695 39.468L45.349 63.3226L42.1777 60.3945L64.1972 36.5409Z",
    fill: "#7a65a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.275391 74.4534H17.1291V136.954H-0.275391V74.4534Z",
    fill: "#345ca3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6234 94.5375H48.029V136.954H30.6234V94.5375Z",
    fill: "#345ca3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5217 61.0636H78.9273V136.954H61.5217V61.0636Z",
    fill: "#345ca3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4205 71.1056H109.826V136.954H92.4205V71.1056Z",
    fill: "#345ca3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32 40.9805H140.725V136.954H123.32V40.9805Z",
    fill: "#345ca3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1302 46.5819C17.1302 51.3883 13.2338 55.2847 8.42738 55.2847C3.62096 55.2847 -0.275391 51.3883 -0.275391 46.5819C-0.275391 41.7755 3.62096 37.8792 8.42738 37.8792C13.2338 37.8792 17.1302 41.7755 17.1302 46.5819Z",
    fill: "#d15371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.725 13.109C140.725 17.9155 136.828 21.8118 132.022 21.8118C127.215 21.8118 123.319 17.9155 123.319 13.109C123.319 8.3026 127.215 4.40625 132.022 4.40625C136.828 4.40625 140.725 8.3026 140.725 13.109Z",
    fill: "#d15371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.826 43.2352C109.826 48.0406 105.93 51.9369 101.123 51.9369C96.3169 51.9369 92.4205 48.0406 92.4205 43.2352C92.4205 38.4288 96.3169 34.5325 101.123 34.5325C105.93 34.5325 109.826 38.4288 109.826 43.2352Z",
    fill: "#d15371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9273 33.1932C78.9273 37.9986 75.0309 41.8949 70.2245 41.8949C65.4181 41.8949 61.5217 37.9986 61.5217 33.1932C61.5217 28.3868 65.4181 24.4905 70.2245 24.4905C75.0309 24.4905 78.9273 28.3868 78.9273 33.1932Z",
    fill: "#d15371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.029 66.6661C48.029 71.4726 44.1326 75.3689 39.3262 75.3689C34.5198 75.3689 30.6234 71.4726 30.6234 66.6661C30.6234 61.8597 34.5198 57.9634 39.3262 57.9634C44.1326 57.9634 48.029 61.8597 48.029 66.6661Z",
    fill: "#d15371"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 141,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.c782657b9abb777642f2927cd70af6d8.svg";
export { ForwardRef as ReactComponent };